<script lang="ts">
  import BottomPanel from '../BottomPanel.svelte'
  import CaptionCue from '../CaptionCue.svelte'
  import LiveProgressBar from './LiveProgressBar.svelte'
  import LiveControlBar from './LiveControlBar.svelte'
  import LiveControlBarMobile from './LiveControlBarMobile.svelte'
</script>

<BottomPanel>
  <CaptionCue />
  {#snippet progressBar()}
    <LiveProgressBar />
  {/snippet}
  {#snippet controlBar()}
    <LiveControlBar />
  {/snippet}
  {#snippet controlBarMobile()}
    <LiveControlBarMobile />
  {/snippet}
</BottomPanel>
